<template>
    <section>
        <!--工具条-->
        <!--<toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;margin-bottom:22px;">
            <el-select v-model="SelStatus" filterable placeholder="请选择会员状态" style="width: 110px">
                <el-option label="全部" value="-1"></el-option>
                <el-option label="激活" value="0"></el-option>
                <el-option label="禁用" value="1"></el-option>
            </el-select>
            <el-date-picker type="date" v-model="DataStartDate" placeholder="注册日期开始" value-format="yyyy-MM-dd">至</el-date-picker>
            至
            <el-date-picker type="date" v-model="DataEndDate" placeholder="注册日期结束" value-format="yyyy-MM-dd"></el-date-picker>
            <el-input v-model="searchVal" placeholder="请输入内容" style="width:300px;margin-left:10px;"></el-input>
            <el-button type="primary" @click="handleQuery()">查询</el-button>
            <el-button type="primary" @click="handleAdd()" v-if="isAdd">新增</el-button>
        </el-col>

        <!--列表-->
        <el-table :data="users"
                  v-loading="listLoading"
                  @select="dialogCheck"
                  @row-click="selectCurrentRow"
                  ref="table"
                  class="custom-tbl"
                  style="width: 100%">
            <!--<el-table-column type="selection" width="50"> </el-table-column>-->
            <el-table-column type="index" :index="indexMethod" label="序号" width="50" fixed> </el-table-column>
            <el-table-column prop="Id" label="会员Id" width="" sortable>
            </el-table-column>
            <el-table-column prop="nickName" label="昵称" width="" sortable>
            </el-table-column>
            <el-table-column prop="Username" label="账号" width="" sortable>
            </el-table-column>
            <!--<el-table-column prop="Name" label="姓名" width="" sortable>
            </el-table-column>-->
            <el-table-column prop="Phone" label="手机号" width="" sortable>
            </el-table-column>
            <el-table-column prop="RechargeBalance" label="余额" width="" sortable>
            </el-table-column>
            <el-table-column prop="Status" label="状态" sortable>
                <template slot-scope="scope">
                    <el-tag :type="scope.row.Status == 0 ? 'success' : 'danger'"
                            disable-transitions>
                        {{ scope.row.Status == 0 ? "激活" : "禁用" }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="CreationTime" label="添加日期" :formatter="formatCreateTime" width sortable></el-table-column>
            <el-table-column label="操作" width="350">
                <template scope="scope">
                    <el-button size="small" @click="handleEdit(scope.$index, scope.row)" v-if="isEdit">编辑</el-button>
                    <el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)" v-if="isDelete">删除</el-button>
                    <el-button type="danger" size="small" @click="handleModifyPwd(scope.$index, scope.row)" v-if="isModifyPwd">修改密码</el-button>
                    <el-button type="danger" size="small" @click="handleModifyRecharge(scope.$index, scope.row)" v-if="isModifyRecharge">修改余额</el-button>

                </template>
            </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="prev, pager, next"
                           @current-change="handleCurrentChange"
                           :page-size="50"
                           :total="total"
                           style="float: right">
            </el-pagination>
        </el-col>

        <!--编辑界面-->
        <el-dialog title="编辑"
                   :visible.sync="editFormVisible"
                   v-model="editFormVisible"
                   :close-on-click-modal="false">
            <el-form :model="editForm"
                     label-width="100px"
                     :rules="editFormRules"
                     ref="editForm">
                <el-form-item label="账号" prop="Username">
                    <el-input v-model="editForm.Username" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="昵称" prop="nickName">
                    <el-input v-model="editForm.nickName" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="Name">
                    <el-input v-model="editForm.Name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="Phone">
                    <el-input v-model="editForm.Phone" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="Password">
                    <el-input v-model="editForm.Password" auto-complete="off"></el-input>(不填写表示使用原密码)
                </el-form-item>
                <el-form-item label="生日" prop="Birth">
                    <el-date-picker type="date" v-model="editForm.Birth" value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
                <!--<el-form-item label="邮箱" prop="Email">
                <el-input v-model="editForm.Email" auto-complete="off"></el-input>
            </el-form-item>-->
                <el-form-item label="状态" prop="Status">
                    <el-radio-group v-model="editForm.Status">
                        <el-radio class="radio" :label="0">激活</el-radio>
                        <el-radio class="radio" :label="1">禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="性别" prop="Gender">
                    <el-radio-group v-model="editForm.Gender">
                        <el-radio class="radio" :label="1">男</el-radio>
                        <el-radio class="radio" :label="2">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="地址" prop="Address">
                    <el-input type="textarea" placeholder="地址" v-model="editForm.Address"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="Remark">
                    <el-input type="textarea" placeholder="备注" v-model="editForm.Remark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary"
                           @click.native="editSubmit"
                           :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>

        <!--新增界面-->
        <el-dialog title="新增"
                   :visible.sync="addFormVisible"
                   v-model="addFormVisible"
                   :close-on-click-modal="false">
            <el-form :model="addForm"
                     label-width="100px"
                     :rules="addFormRules"
                     ref="addForm">
                <el-form-item label="账号" prop="Username">
                    <el-input v-model="addForm.Username" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="昵称" prop="nickName">
                    <el-input v-model="addForm.nickName" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="Name">
                    <el-input v-model="addForm.Name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="Phone">
                    <el-input v-model="addForm.Phone" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="Password">
                    <el-input v-model="addForm.Password" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="生日" prop="Birth">
                    <el-date-picker type="date" v-model="addForm.Birth" value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
                <!--<el-form-item label="邮箱" prop="Email">
                <el-input v-model="addForm.Email" auto-complete="off"></el-input>
            </el-form-item>-->
                <el-form-item label="状态" prop="Status">
                    <el-radio-group v-model="addForm.Status">
                        <el-radio class="radio" :label="0">激活</el-radio>
                        <el-radio class="radio" :label="1">禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="性别" prop="Gender">
                    <el-radio-group v-model="addForm.Gender">
                        <el-radio class="radio" :label="1">男</el-radio>
                        <el-radio class="radio" :label="2">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="地址" prop="Address">
                    <el-input type="textarea" placeholder="地址" v-model="addForm.Address"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="Remark">
                    <el-input type="textarea" placeholder="备注" v-model="addForm.Remark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">取消</el-button>
                <el-button type="primary"
                           @click.native="addSubmit"
                           :loading="addLoading">提交</el-button>
            </div>
        </el-dialog>


        <!--修改密码界面-->
        <el-dialog title="修改密码" :visible.sync="editPwdFormVisible" v-model="editPwdFormVisible" :close-on-click-modal="false">
            <el-form :model="editPwdForm" label-width="120px" :rules="editPwdFormRules" ref="editPwdForm">
                <el-form-item label="姓名" prop="TrueName">
                    {{editPwdForm.TrueName}}
                </el-form-item>
                <el-form-item label="新密码" prop="NewPwd">
                    <el-input v-model="editPwdForm.NewPwd" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="确认新密码" prop="ConNewPwd">
                    <el-input v-model="editPwdForm.ConNewPwd" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editPwdFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editPwdSubmit" :loading="editPwdLoading">提交</el-button>
            </div>
        </el-dialog>

        <!--修改余额界面-->
        <el-dialog title="修改密码" :visible.sync="editRechargeFormVisible" v-model="editPRechargeFormVisible" :close-on-click-modal="false">
            <el-form :model="editRechargeForm" label-width="120px" :rules="editRechargeFormRules" ref="editRechargeForm">
                <el-form-item label="姓名" prop="TrueName">
                    {{editRechargeForm.TrueName}}
                </el-form-item>
                <el-form-item label="当前余额" prop="RechargeBalance">
                    {{editRechargeForm.RechargeBalance}}
                </el-form-item>
                <el-form-item label="调整金额" prop="ModifyRecharge">
                    <el-input-number v-model="editRechargeForm.ModifyRecharge"></el-input-number>
                </el-form-item>
                <el-form-item label="说明">
                    如果是减少余额，那么调整金额就输入要减少金额的负数（比如要减少20，那么调整金额就添加-20），如果是增加余额，那么输入一个要增加的金额。
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editRechargeFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editRechargeSubmit" :loading="editRechargeLoading">提交</el-button>
            </div>
        </el-dialog>

    </section>
</template>

<script>
    import util from "../../../util/date";
    /*  import address from "../../../util/address.json"; //全国省市区街道数据*/
    import {
        getPageUserManage,
        removeUserManage,
        editUserManage,
        addUserManage,
        modifyUserPassword,
        modifyUserRecharge
    } from "../../api/api";
    import { getButtonList } from "../../promissionRouter";
    /* import Toolbar from "../../components/Toolbar";*/

    export default {
        /* components: { Toolbar, VDistpicker },*/
        data() {
            return {
                filters: {
                    name: "",
                },
                searchVal: "",
                SelStatus: "-1",
                DataStartDate: "",
                DataEndDate: "",
                users: [],
                total: 0,
                buttonList: [],
                currentRow: null,
                page: 1,
                listLoading: false,
                sels: [], //列表选中列

                ////  省数据
                //addressData: [],
                ////  市数据
                //cityData: [],
                //// 区数据
                //areaData: [],

                /*show: false,*/

                addDialogFormVisible: false,
                editFormVisible: false, //编辑界面是否显示
                editLoading: false,
                editFormRules: {
                    nickName: [{ required: true, message: "请输入昵称", trigger: "blur" },],
                    Username: [{ required: true, message: "请输入账号", trigger: "blur" },],
                    Name: [{ required: true, message: "请输入姓名", trigger: "blur" },],
                    Address: [{ required: true, message: "请输入地址", trigger: "blur" }],
                    Phone: [{ required: true, message: "请输入手机号", trigger: "blur" }]
                },
                //编辑界面数据
                editForm: {
                    nickName: "",
                    Username: "",
                    Password: "",
                    Name: "",
                    Phone: "",
                    Address: "",
                    //Email: "",
                    Gender: 1,
                    Status: 0,
                    Remark: ""
                },

                isResouceShow: 0,
                addFormVisible: false, //新增界面是否显示
                addLoading: false,
                addFormRules: {
                    nickName: [{ required: true, message: "请输入昵称", trigger: "blur" },],
                    Username: [{ required: true, message: "请输入账号", trigger: "blur" },],
                    Name: [{ required: true, message: "请输入姓名", trigger: "blur" },],
                    Address: [{ required: true, message: "请输入地址", trigger: "blur" }],
                    Phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
                    Password: [{ required: true, message: "请输入密码", trigger: "blur" }]
                },
                //新增界面数据
                addForm: {
                    nickName: "",
                    Username: "",
                    Password: "",
                    Name: "",
                    Phone: "",
                    Address: "",
                    //Email: "",
                    Gender: 1,
                    Status: 0,
                    Remark: ""
                },

                isEdit: false,
                isDelete: false,
                isAdd: false,
                isModifyPwd: false,
                isModifyRecharge:false,

                editPwdFormVisible: false,//新增界面是否显示
                editPwdLoading: false,
                editPwdFormRules: {
                    NewPwd: [
                        { required: true, message: '请输入密码', trigger: 'blur' }
                    ],
                    ConNewPwd: [
                        { required: true, message: '请输入确认密码', trigger: 'blur' }
                    ]
                },
                //新增界面数据
                editPwdForm: {
                    TrueName: '',
                    NewPwd: '',
                    ConNewPwd: ''
                },


                editRechargeFormVisible: false,//新增界面是否显示
                editRechargeLoading: false,
                editRechargeFormRules: {
                    ModifyRecharge: [
                        { required: true, message: '请输入调整的金额', trigger: 'blur' }
                    ]
                },
                //新增界面数据
                editRechargeForm: {
                    Id: 0,
                    TrueName: '',
                    RechargeBalance: 0,
                    ModifyRecharge: 0,
                    UserId: 0
                },
            };
        },
        methods: {
            indexMethod(index) {
                index = (index + 1) + (this.page - 1) * 50;
                //index = this.total - (this.page - 1) * 20 - index
                return index;
            },
            dialogCheck(selection, row) {
                this.currentRow = null;
                this.$refs.table.clearSelection();
                if (selection.length === 0) {
                    return;
                }
                if (row) {
                    this.selectCurrentRow(row);
                }
            },
            selectCurrentRow(val) {
                if (val) {
                    this.currentRow = val;
                    this.$refs.table.clearSelection();
                    this.$refs.table.toggleRowSelection(val, true);
                }
            },
            callFunction(item) {
                this.filters = {
                    name: item.search,
                };
                this[item.Func].apply(this, item);
            },
            formatCreateTime: function (row, column) {
                return !row.CreationTime || row.CreationTime == ""
                    ? ""
                    : util.formatDate.format(new Date(row.CreationTime), "yyyy-MM-dd hh:mm");
            },
            ////性别显示转换
            //formatSex: function (row, column) {
            //    return row.sex == 1 ? "男" : row.sex == 0 ? "女" : "未知";
            //},
            //formatBirth: function (row, column) {
            //    return !row.birth || row.birth == ""
            //        ? ""
            //        : util.formatDate.format(new Date(row.birth), "yyyy-MM-dd");
            //},
            handleCurrentChange(val) {
                this.page = val;
                this.handleQuery();
            },
            //获取用户列表
            handleQuery() {
                let para = {
                    page: this.page,
                    key: this.searchVal,//this.filters.name,
                    status: this.SelStatus,
                    startTime: this.DataStartDate,
                    endTime: this.DataEndDate
                };
                this.listLoading = true;

                //testapi();
                //NProgress.start();
                getPageUserManage(para).then((res) => {
                    this.total = res.data.response.dataCount;
                    this.users = res.data.response.data;
                    this.listLoading = false;
                    //NProgress.done();
                });
            },
            //删除
            handleDel(index, cRow) {
                this.currentRow = cRow;
                let row = this.currentRow;
                if (!row) {
                    this.$message({
                        message: "请选择要删除的一行数据！",
                        type: "error",
                    });

                    return;
                }
                this.$confirm("确认删除该记录吗?", "提示", {
                    type: "warning",
                })
                    .then(() => {
                        this.listLoading = true;
                        //NProgress.start();
                        let para = { id: row.Id };
                        removeUserManage(para).then((res) => {
                            if (util.isEmt.format(res)) {
                                this.listLoading = false;
                                return;
                            }
                            this.listLoading = false;
                            //NProgress.done();
                            if (res.data.success) {
                                this.$message({
                                    message: "删除成功",
                                    type: "success",
                                });
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: "error",
                                });
                            }
                            this.page = 1;
                            this.handleQuery();
                        });
                    })
                    .catch(() => { });
            },
            //显示编辑界面
            handleEdit(index, cRow) {
                this.currentRow = cRow;
                let row = this.currentRow;
                if (!row) {
                    this.$message({
                        message: "请选择要编辑的一行数据！",
                        type: "error",
                    });

                    return;
                }
                this.editFormVisible = true;
                this.editForm = Object.assign({}, row);

                //getRoleListPage().then((res) => {
                //    this.roles = res.data.response.data;
                //});

                //let para = { pid: 0 };
                //getDepartmentTree(para).then((res) => {
                //    ++this.isResouceShow;
                //    this.options.push(res.data.response);
                //});
            },
            //显示新增界面
            handleAdd() {
                this.addFormVisible = true;
                this.addForm = {
                    nickName: "",
                    Username: "",
                    Password: "",
                    Name: "",
                    Phone: "",
                    Address: "",
                    //Email: "",
                    Gender: 1,
                    Status: 0,
                    Remark: ""
                };

                //let para = { pid: 0 };
                //getDepartmentTree(para).then((res) => {
                //    ++this.isResouceShow;
                //    this.options.push(res.data.response);
                //});
            },
            //编辑
            editSubmit: function () {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.$confirm("确认提交吗？", "提示", {}).then(() => {
                            this.editLoading = true;
                            //NProgress.start();
                            let para = Object.assign({}, this.editForm);
                            if (para.nickName == null || para.nickName == "") {
                                this.$message({
                                    message: "请输入昵称",
                                    type: "success",
                                });
                                this.editLoading = false;
                                return;
                            }
                            if (para.Username == null || para.Username == "" || para.Username.length < 6) {
                                this.$message({
                                    message: "请输入账号，长度不小于6位",
                                    type: "success",
                                });
                                this.editLoading = false;
                                return;
                            }
                            if (para.Name == null || para.Name == "") {
                                this.$message({
                                    message: "请输入姓名",
                                    type: "success",
                                });
                                this.editLoading = false;
                                return;
                            }
                            if (para.Phone == null || para.Phone == "") {
                                this.$message({
                                    message: "请输入手机号",
                                    type: "success",
                                });
                                this.editLoading = false;
                                return;
                            }

                            editUserManage(para).then((res) => {
                                if (util.isEmt.format(res)) {
                                    this.editLoading = false;
                                    return;
                                }
                                if (res.data.success) {


                                    this.editLoading = false;
                                    this.$message({
                                        message: res.data.msg,
                                        type: "success",
                                    });
                                    this.$refs["editForm"].resetFields();
                                    this.editFormVisible = false;
                                    this.handleQuery();
                                } else {
                                    this.$message({
                                        message: res.data.msg,
                                        type: "error",
                                    });
                                    this.editLoading = false;
                                }
                            });
                        });
                    }
                });
            },
            //新增
            addSubmit: function () {
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.$confirm("确认提交吗？", "提示", {}).then(() => {
                            this.addLoading = true;
                            //NProgress.start();
                            let para = Object.assign({}, this.addForm);
                            //para.birth =
                            //    !para.birth || para.birth == ""
                            //        ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                            //        : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");

                            //para.DepartmentId = para.Dids.pop();
                            if (para.nickName == null || para.nickName == "") {
                                this.$message({
                                    message: "请输入昵称",
                                    type: "success",
                                });
                                this.editLoading = false;
                                return;
                            }
                            if (para.Username == null || para.Username == "" || para.Username.length < 6) {
                                this.$message({
                                    message: "请输入账号，长度不小于6位",
                                    type: "success",
                                });
                                this.addLoading = false;
                                return;
                            }
                            if (para.Name == null || para.Name == "") {
                                this.$message({
                                    message: "请输入姓名",
                                    type: "success",
                                });
                                this.addLoading = false;
                                return;
                            }
                            if (para.Phone == null || para.Phone == "") {
                                this.$message({
                                    message: "请输入手机号",
                                    type: "success",
                                });
                                this.addLoading = false;
                                return;
                            }
                            console.log("para.Password.length=" + para.Password.length);
                            if (para.Password == null || para.Password == "" || para.Password.length < 6) {
                                this.$message({
                                    message: "请输入密码，长度不小于6位",
                                    type: "success",
                                });
                                this.addLoading = false;
                                return;
                            }

                            addUserManage(para).then((res) => {
                                if (util.isEmt.format(res)) {
                                    this.addLoading = false;
                                    return;
                                }

                                if (res.data.success) {

                                    this.addLoading = false;
                                    //NProgress.done();
                                    this.$message({
                                        message: res.data.msg,
                                        type: "success",
                                    });
                                    this.$refs["addForm"].resetFields();
                                    this.addFormVisible = false;
                                    this.handleQuery();
                                } else {
                                    this.$message({
                                        message: res.data.msg,
                                        type: "error",
                                    });
                                    this.addLoading = false;
                                }
                            });
                        });
                    }
                });
            },
            //显示新增界面
            handleModifyPwd(index, cRow) {
                this.currentRow = cRow;
                let row = this.currentRow;
                if (!row) {
                    this.$message({
                        message: "请选择要编辑的一行数据！",
                        type: "error"
                    });
                    return;
                }

                let that = this;
                this.editForm = {};

                that.editPwdLoading = true;
                that.editPwdFormVisible = true;
                that.editPwdForm = Object.assign({}, row);
                console.log(that.editPwdForm.Name);
                //this.editPwdForm.TrueName = that.editPwdForm.TrueName;
                //that.editPwdForm.TrueName = row.;
                this.editPwdForm = {
                    Id: that.editPwdForm.Id,
                    TrueName: that.editPwdForm.Name,
                    NewPwd: '',
                    ConNewPwd: ''
                };
                this.editPwdLoading = false;
            },
            //修改密码
            editPwdSubmit: function () {
                this.$refs.editPwdForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.editPwdLoading = true;
                            //NProgress.start();
                            let para = Object.assign({}, this.editPwdForm);
                            if (para.Id <= 0) {
                                this.$message({
                                    message: "请选择要编辑的一行数据！",
                                    type: "error"
                                });
                                this.editPwdLoading = false;
                                return;
                            }
                            if (para.NewPwd == null || para.NewPwd == "" || para.NewPwd.length < 6) {
                                this.$message({
                                    message: "密码不能小于6位！",
                                    type: "error"
                                });
                                this.editPwdLoading = false;
                                return;
                            }
                            if (para.ConNewPwd == null || para.ConNewPwd == "" || para.ConNewPwd.length < 6) {
                                this.$message({
                                    message: "确认密码不能小于6位！",
                                    type: "error"
                                });
                                this.editPwdLoading = false;
                                return;
                            }
                            if (para.NewPwd != para.ConNewPwd) {
                                this.$message({
                                    message: "密码和确认密码不一致！",
                                    type: "error"
                                });
                                this.editPwdLoading = false;
                                return;
                            }
                            console.log(para.Id);
                            para.UserId = para.Id;
                            para.PassWord = para.NewPwd;
                            modifyUserPassword(para).then((res) => {

                                if (util.isEmt.format(res)) {
                                    this.editPwdLoading = false;
                                    return;
                                }
                                if (res.data.success) {
                                    this.editPwdLoading = false;
                                    //NProgress.done();
                                    this.$message({
                                        message: res.data.msg,
                                        type: 'success'
                                    });
                                    this.$refs['editPwdForm'].resetFields();
                                    this.editPwdFormVisible = false;
                                    this.handleQuery();
                                } else {
                                    this.editPwdLoading = false;
                                    this.$message({
                                        message: res.data.msg,
                                        type: 'error'
                                    });
                                    this.editPwdLoading = false;
                                }
                            });
                        });
                    }
                });
            },

            //显示修改余额界面
            handleModifyRecharge(index, cRow) {
                this.currentRow = cRow;
                let row = this.currentRow;
                if (!row) {
                    this.$message({
                        message: "请选择要编辑的一行数据！",
                        type: "error"
                    });
                    return;
                }

                let that = this;
                this.editForm = {};

                that.editRechargeLoading = true;
                that.editRechargeFormVisible = true;
                that.editRechargeForm = Object.assign({}, row);
                console.log(that.editRechargeForm.Name);
                //this.editPwdForm.TrueName = that.editPwdForm.TrueName;
                //that.editPwdForm.TrueName = row.;
                this.editRechargeForm = {
                    Id: that.editRechargeForm.Id,
                    TrueName: that.editRechargeForm.Name,
                    RechargeBalance: that.editRechargeForm.RechargeBalance,
                    ModifyRecharge: 0,
                    UserId: that.editRechargeForm.Id,
                };
                this.editRechargeLoading = false;
            },
            //修改余额
            editRechargeSubmit: function () {
                this.$refs.editRechargeForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.editRechargeLoading = true;
                            //NProgress.start();
                            let para = Object.assign({}, this.editRechargeForm);
                            if (para.Id <= 0) {
                                this.$message({
                                    message: "请选择要编辑的一行数据！",
                                    type: "error"
                                });
                                this.editRechargeLoading = false;
                                return;
                            }
                            if (para.ModifyRecharge == null || para.ModifyRecharge==0) {
                                this.$message({
                                    message: "请输入调整的金额！",
                                    type: "error"
                                });
                                this.editRechargeLoading = false;
                                return;
                            }
                            console.log(para.Id);
                            para.UserId = para.Id;
                            modifyUserRecharge(para).then((res) => {

                                if (util.isEmt.format(res)) {
                                    this.editRechargeLoading = false;
                                    return;
                                }
                                if (res.data.success) {
                                    this.editRechargeLoading = false;
                                    //NProgress.done();
                                    this.$message({
                                        message: res.data.msg,
                                        type: 'success'
                                    });
                                    this.$refs['editRechargeForm'].resetFields();
                                    this.editRechargeFormVisible = false;
                                    this.handleQuery();
                                } else {
                                    this.editRechargeLoading = false;
                                    this.$message({
                                        message: res.data.msg,
                                        type: 'error'
                                    });
                                    this.editRechargeLoading = false;
                                }
                            });
                        });
                    }
                });
            },


        },
        mounted() {
            this.handleQuery();

            let routers = window.localStorage.router
                ? JSON.parse(window.localStorage.router)
                : [];
            this.buttonList = getButtonList(this.$route.path, routers);

            this.buttonList.forEach(item => {
                if (item.Func == "handleEdit") {
                    this.isEdit = true;
                }
                else if (item.Func == "handleDel") {
                    this.isDelete = true;
                }
                else if (item.Func == "handleAdd") {
                    this.isAdd = true;
                }
                else if (item.Func == "handleModifyPwd") {
                    this.isModifyPwd = true;
                } else if (item.Func == "handleModifyRecharge") {
                    this.isModifyRecharge = true;
                }
            });

        },
    };
</script>

<style scoped>
    .custom-tbl /deep/ .has-gutter .el-checkbox {
        display: none;
    }

    .pwrap {
        height: 400px;
        overflow-y: auto;
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
    }

        .pwrap .distpicker-address-wrapper {
            color: #999;
        }

        .pwrap .address-header {
            position: fixed;
            bottom: 400px;
            width: 100%;
            background: #000;
            color: #fff;
        }

            .pwrap .address-header ul li {
                flex-grow: 1;
                text-align: center;
            }

            .pwrap .address-header .active {
                color: #fff;
                border-bottom: #666 solid 8px
            }

        .pwrap .address-container .active {
            color: #000;
        }
</style>
